export var version = 'local';
//# sourceMappingURL=version.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@apollo/client/version.js
// module id = ./node_modules/@apollo/client/version.js
// module chunks = 53 54